import React from 'react';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { usePostHog } from 'posthog-js/react';

import AnalyticsPageView from '../analytics/Analytics';
import { isAnalyticsEnabled } from '../analytics/env';

const PostHogPageViewShell = ({ children }) => {
  const location = useLocation();
  const posthog = usePostHog();
  const activePosthog = isAnalyticsEnabled() && posthog ? posthog : null;

  return (
    <AnalyticsPageView posthog={activePosthog} location={location}>
      {children}
    </AnalyticsPageView>
  );
};

export default PostHogPageViewShell;
